import styled from "styled-components";
import { Space } from "antd";
import { DownloadTopImg ,IMG_PAGE_BG} from '@assets';

export const RootContainer = styled.div`
	min-height: calc(100vh - 70px);
	text-align: center;
	overflow: hidden;
  text-align: center;

  background-image: url(${IMG_PAGE_BG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  //for star line icon
  svg{
    width: calc(100% - 32px);
  }
`;

export const Title = styled.div`
	margin-bottom: 16px;

  color: #FFF;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px; /* 141.667% */
`;

export const SocialWrapper = styled(Space)`
	gap: 15px !important;

	svg {
		width: 40px;
		height: auto;
	}
`;

export const DownloadWrapper = styled.div`
	gap: 15px !important;
  width: calc(100% - 60px);
  padding: 0 30px;
  margin: 16px 0;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a {
    width: 100%;
    display: flex;
  } 
  
  svg{
    width: 100%;
    height: auto;
  }
`;

export const Wrapper = styled.div`
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.30);
  backdrop-filter: blur(2px);

  width: calc(100% - 64px);
  padding: 16px;
  margin-top: 16px;
  margin-left: 16px;
  margin-bottom: 30px;
`

export const SocialTitle = styled.p`
  color: #FFD647;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 26px; /* 162.5% */

  margin: 0 0 16px;
`

export const TopImage = styled.img.attrs({
  alt: 'topbg',
  src: DownloadTopImg,
})`
width: 100%;
height: auto;
`;